<div [ngClass]="{'mb-0': !hideContent, 'mb-3': hideContent}">
    <div class="row m-0">
        <div (click)="toggleContent()"
             class="col-12 section-header">
            <span class="fas section-toggle mr-2"
                  [ngClass]="{'fa-angle-down': !hideContent, 'fa-angle-up': hideContent}"></span>
            <span class="section-title section-title--slim">
              {{status.sortNumber}}.	
              <ng-container *ngIf="!role.bot || status.sortNumber !== 2">{{status.name | translate}}</ng-container>
              <ng-container *ngIf="role.bot && status.sortNumber === 2">{{'Bot failed' | translate}}</ng-container>
            </span>
            <span *ngIf="status.roleStatusType=='UserDefinedStatus' || status.roleStatusType=='FileDeclineStatus' || status.roleStatusType=='FileRejectStatus'"
                  class="ml-3">
      				<span (click)="toggleActive(status);$event.stopPropagation();" class="align-middle mr-2">
      				  <i class="preview-icon fas {{status.active ? 'fa-toggle-large-on toggle-primary':'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive'}}" class="mr-2"></i>
      				</span>
              <span *ngIf="!status.active">{{'The status is not activated for this role.' | translate}}</span>
              <span *ngIf="status.active">{{'The status is activated for this role.' | translate}}</span>
            </span>
            <confirmation [buttonName]="'general.delete'"
                          [showTrashIcon]="true"
                          [question]="'confirm.areyousure'"
                          (isConfirmed)="deleteRoleStatus($event, status.id)"
                          class="float-right"
                          *ngIf="status.id && status.roleStatusType=='UserDefinedStatus'"></confirmation>
        </div>
    </div>
    <ng-container *ngIf="hideContent">
        <div class="row m-0 mt-3">
          <div class="col-12 mt-lg-0">
              <!-- for File Validated Status -->
              <div *ngIf="status.roleStatusType=='FileValidatedStatus'">
                  <label class="input-label">{{ 'roles.destination' | translate }}</label>
                  <ng-select [(ngModel)]="selectedRoles"
                            bindLabel="text"
                            bindValue="id"
                            [clearable]="true"
                            [multiple]="true"
                            [items]="filteredRoles"
                            (add)="selected()"
                            (remove)="removed()"
                            (clear)="removed()"
                            class=""
                            placeholder="{{ 'Process end - click to assign' | translate }}"></ng-select>
              </div>
              <!-- can have multiple destinations -->
              <div *ngIf="status.roleStatusType=='UserDefinedStatus' && status.active">
                  <label class="input-label">{{ 'roles.destination' | translate }}</label>
                  <ng-select [(ngModel)]="selectedRoles"
                            bindLabel="text"
                            bindValue="id"
                            [clearable]="false"
                            [multiple]="true"
                            [items]="allRoles"
                            (add)="selected()"
                            (remove)="removed()"
                            class=""
                            placeholder="{{ 'Click to select' | translate }}"></ng-select>
              </div>
              <!-- can have only 1 destination -->
              <div *ngIf="(status.roleStatusType=='FileDeclineStatus' && status.active)">
                  <label class="input-label">{{ 'roles.destination' | translate }}</label>
                  <ng-select [(ngModel)]="selectedRoles[0]"
                            bindLabel="text"
                            bindValue="id"
                            [clearable]="true"
                            [multiple]="false"
                            [items]="allRoles"
                            (change)="selectedOne($event)"
                            placeholder="{{ 'Click to select' | translate }}"
                            class=""></ng-select>
              </div>
              <div *ngIf="status.roleStatusType=='FileDeclineStatus' && status.active && role?.type !== 'BotRole' && role?.assignedTo === 'processing'" class="mt-3">
                <label class="input-label">{{ 'Rejection reasons' | translate }}</label>
                <ng-select [(ngModel)]="status.rejectionCatalogId"
                          bindLabel="name"
                          bindValue="id"
                          [clearable]="true"
                          [multiple]="false"
                          [items]="rejectionReasons"
                          (change)="saveRoleStatus(status.roleStatusType)"
                          placeholder="{{ 'Click to select' | translate }}"
                          class=""></ng-select>
            </div>
          </div>
        </div>
        <div class="row m-0 mt-5">
          <div class="col-12 col-md-12 col-lg-4 mt-4 mt-md-4 mt-lg-0">
              <label class="d-flex list-title with-border row m-0">
                <div class="col-6">
                  {{ 'roles.messages' | translate }}
                  <span (click)="initSectionData('MESSAGE')"
                        class="addBtn services-icon--add ml-2">
                      {{'Add' | translate}}
                  </span>
                </div>
                <div class="col-5">
                    {{'Recipient(s)' | translate}}
                </div>
              </label>
              <div class="row m-0">
                  <div class="col-12">
                      <div *ngFor="let statusMsg of statusMessages; last as isLast"
                            class="row align-items-center list-row cursor-pointer {{isLast ? 'last' : ''}}">
                          <div class="col-6" (click)="openMessageEdit(statusMsg.message, 'MESSAGE')">
                              {{statusMsg.message?.name}}
                          </div>
                          <div class="col-5" (click)="openStatusMessageEdit(statusMsg, 'MESSAGE')">
                              <span *ngFor="let receiver of statusMsg.receivers" class="badge badge-toShow mr-1">
                                {{receiver.name | translate}}
                              </span>
                          </div>
                          <div class="col-1">
                              <i (click)="removeStatusMessage(statusMsg)"
                                class="fas fa-times btn-xs btn-bordered btn-danger btn-icon"></i>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="col-12 col-md-12 col-lg-4 mt-4 mt-md-4 mt-lg-0">
              <label class="d-flex list-title with-border row m-0">
                <div class="col-6">
                  {{ 'annexes.alerts.alert' | translate }}
                  <span (click)="initSectionData('ALERT')"
                        class="addBtn services-icon--add ml-2">
                      {{'Add' | translate}}
                  </span>
                </div>
                <div class="col-5">
                    {{'Recipient(s)' | translate}}
                </div>
              </label>
              <div class="row m-0">
                  <div class="col-12">
                      <div *ngFor="let statusMsg of statusAlerts; last as isLast"
                            class="row align-items-center list-row cursor-pointer {{isLast ? 'last' : ''}}">
                          <div class="col-6" (click)="openMessageEdit(statusMsg.message, 'ALERT')">
                              {{statusMsg.message?.name}}
                          </div>
                          <div class="col-5" (click)="openStatusMessageEdit(statusMsg, 'ALERT')">
                            <span *ngFor="let receiver of statusMsg.receivers" class="badge badge-toShow mr-1">
                              {{receiver.name}}
                            </span>
                          </div>
                          <div class="col-1">
                              <i (click)="removeStatusAlert(statusMsg)"
                                class="fas fa-times btn-xs btn-bordered btn-danger btn-icon"></i>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
      </ng-container>
</div>
